<dx-tree-view [dataSource]="this.adminMenuItems" (onItemClick)="this.selectAdminMenuItem($event)"></dx-tree-view>
